import { createContext, useContext } from 'react';
import noop from 'utils/noop';
import { StartNodeData, Workflow } from 'modules/workflows/types';

export interface StartNodeContextState {
  /** Is journey linked from other journeys */
  hasLinkedJourneys: boolean;
  /** Is the tile editor read only */
  isReadOnly: boolean;
  /** Initial node data for start tile */
  initialNodeData: StartNodeData;
  /** Node data for start tile, saved on editor update */
  nodeData: StartNodeData;
  /** Set is journey linked from other journeys */
  setHasLinkedJourneys: (isLinked: boolean) => void;
  /** Handle node data update when a field is changed */
  setNodeData: (data: Partial<StartNodeData>) => void;
  /** Handle workflow data update when a field is changed */
  setWorkflowData: (data: Partial<Workflow>) => void;
  /** Workflow data for start tile, saved on editor update */
  workflowData: Partial<Workflow>;
}

export const StartNodeContext = createContext<StartNodeContextState>({
  hasLinkedJourneys: false,
  isReadOnly: false,
  initialNodeData: {
    nodeClass: '',
    nodeSuperClass: '',
  },
  nodeData: {
    nodeClass: '',
    nodeSuperClass: '',
  },
  setHasLinkedJourneys: noop,
  setNodeData: noop,
  setWorkflowData: noop,
  workflowData: {},
});

export const useStartNodeContext = () => useContext(StartNodeContext);
